import { DestroyRef, inject, Injector } from '@angular/core';
import { HealthInsuranceItem } from '@common/health-insurances/shared';
import { MembershipRegistrationPluginSummaryComponent } from '@common/membership/frontend-shared';
import { CrudServiceFactory } from '@core/frontend-shared/api/crud-service';
import { sharedInjectorForFrontend } from '@core/frontend-shared/providers';
import { RouterLinkResolverService } from '@core/shared/feature';
import { VIRTUAL_PROPS_ACCESSOR } from '@core/shared/virtual-properties';
import { Insurance2025MembershipPlugin } from '@pflegetheke/membership-plugins-insurance/shared';
import { MembershipRegistrationFormInsurance2025Component } from './registration-form.component';
import * as i0 from "@angular/core";
// NOTE: class has no provider. MembershipPluginsService.instancePlugins will use ModuleRef.create to instantiate it.
export let Insurance2025FrontendMembershipPlugin = /*#__PURE__*/(() => {
  class Insurance2025FrontendMembershipPlugin extends Insurance2025MembershipPlugin {
    constructor(injector) {
      super(sharedInjectorForFrontend(injector));
      this.healthInsurances = [];
      this.crud = inject(CrudServiceFactory).useDestroyRef(inject(DestroyRef)).createCrudService(HealthInsuranceItem).useCrudEndpoint('public');
      this.crud.readMany().subscribe(items => {
        this.healthInsurances = items;
      });
    }
    getInsuranceById(alias) {
      return this.healthInsurances.find(i => i.alias === alias);
    }
    getRegistrationComponent() {
      return MembershipRegistrationFormInsurance2025Component;
    }
    getSummaryComponent() {
      return MembershipRegistrationPluginSummaryComponent;
    }
    getAccountData(data) {
      return {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        username: data.email,
        // password will be generated on server side
        [VIRTUAL_PROPS_ACCESSOR]: {
          phone: data.phone,
          allow3rdPartyContact: data.allow3rdPartyContact
        }
      };
    }
    getDataToPersist(data) {
      return {
        insuranceId: data.insuranceId,
        insuranceMembershipId: data.insuranceMembershipId,
        address: data.address,
        zipcode: data.zipcode,
        city: data.city,
        specifyNursedPerson: data.specifyNursedPerson,
        nursed_insuranceId: data.nursed_insuranceId,
        nursed_insuranceMembershipId: data.nursed_insuranceMembershipId,
        nursed_firstName: data.nursed_firstName,
        nursed_lastName: data.nursed_lastName
      };
    }
    getCategorization(data) {
      return data.insuranceId;
    }
    getRegistrationCompletedButton() {
      const resolver = this.injector.get(RouterLinkResolverService);
      const link = resolver.resolveRouterLink('frontend', 'questionCategories');
      return {
        label: "Weiter zu den Videos",
        link
      };
    }
    static {
      this.ɵfac = function Insurance2025FrontendMembershipPlugin_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Insurance2025FrontendMembershipPlugin)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: Insurance2025FrontendMembershipPlugin,
        factory: Insurance2025FrontendMembershipPlugin.ɵfac
      });
    }
  }
  return Insurance2025FrontendMembershipPlugin;
})();